<template>
    <living-box-component :active="!$_.isEmpty(activeList)" v-on:update:active="closeList" v-on:update:full-screen="hideClick" :expandable="!editing" @click="handleClick"
                          :full-screen="fullScreen">
        <template v-slot:main>
            <scroll-hide-nav :nav-manupulation="!editing" :class="editing ? 'branch-manipulation' : ''" @scroll-direction="showEditBtns = $event">
                <header-navigation></header-navigation>
                <div class="max-w-content">
                    <div v-show="!editing">
                        <div v-show="currentTab" class="create-branch" @click="createBranch">
                            <a href @click.prevent>
                                <icon-base width="13" height="13" viewBox="0 0 13 13"><icon-plus/></icon-base>
                                Создать ветку
                            </a>
                        </div>
                        <component-switcher>
                            <branches-list :branchList="getTabContent" :draggable="!!currentTab" :key="currentTab"></branches-list>
                        </component-switcher>
                    </div>
                    <edit-branch v-show="editing===EDIT_BRANCH || editing===COPY_BRANCH" :class="!showEditBtns ? 'hide-btns' : ''"></edit-branch>
                    <create-branch v-if="editing===CREATE_BRANCH" :class="!showEditBtns ? 'hide-btns' : ''"></create-branch>
                </div>
            </scroll-hide-nav>
            <pre-loader-component :visible="loading"></pre-loader-component>
        </template>
        <template v-slot:leaving>
            <active-list v-if="!$_.isEmpty(activeList) && !editing" :post="activeList" @close="closeList"></active-list>
            <add-checklists v-if="!!editing" @close="closeList(false)"></add-checklists>
        </template>
    </living-box-component>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import PreLoaderComponent from "../common/PreLoader";
    import LivingBoxComponent from "../common/LivingBoxComponent";
    import BranchesList from "./BranchesList";
    import ActiveList from "./ActiveList";
    import EditBranch from "./EditBranch";
    import AddChecklists from "./AddChecklists";
    import {EDIT_BRANCH, COPY_BRANCH, CREATE_BRANCH} from "../../constants/common";
    import CreateBranch from "./CreateBranch";
    import IconBase from "../common/IconBase";
    import IconPlus from "../common/icons/IconPlus";
    import HeaderNavigation from "../common/HeaderNavigation";
    import ScrollHideNav from "../common/ScrollHideNav";
    import ComponentSwitcher from "../common/ComponentSwitcher";


    export default {
        name: 'check-list-component-box',
        components: {
            ComponentSwitcher,
            ScrollHideNav,
            HeaderNavigation,
            IconPlus,
            IconBase,
            CreateBranch,
            AddChecklists,
            EditBranch,
            ActiveList,
            BranchesList,
            LivingBoxComponent,
            PreLoaderComponent,
        },
        data() {
            return {
                currentScrollPosition: 0,
                ops: {
                    vuescroll: {
                        pullRefresh: {
                            enable: true
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                },
                tabs: [
                    {
                        id: 0,
                        title: 'Общие'
                    },
                    {
                        id: 1,
                        title: 'Мои'
                    },
                ],
                showEditBtns: true,
                EDIT_BRANCH: EDIT_BRANCH,
                COPY_BRANCH: COPY_BRANCH,
                CREATE_BRANCH: CREATE_BRANCH
            }
        },
        computed: {
            ...mapState({
                loading: state => state.checkLists.loading,
                activeList: state => state.checkLists.activeList,
                fullScreen: state => state.checkLists.fullScreen,
                editing: state => state.checkLists.controlType,
                common: state => state.checkLists.common,
                personal: state => state.checkLists.personal,
                currentTab: state => state.headerNav.active
            }),
            getTabContent() {
                if (this.currentTab) {
                    return this.personal
                } else {
                    return this.common
                }
            },
            postsListRows() {
                return Math.round(this.posts.length / 2);
            },
            firstLoading() {
                return this.loading && !this.posts.length
            }

        },
        methods: {
            ...mapActions([
                'visibleNav'
            ]),
            ...mapActions('checkLists', [
                'getLists',
                'createBranch',
                'setActiveList',
                'getList'
            ]),
            ...mapMutations('checkLists', [
                'setFullScreen',
                'setControlsVisibility'
            ]),
            ...mapMutations([
                'setHeaderNavItems',
                'setHeaderNavActive'
            ]),
            switchPost() {
                this.setFullScreen(!this.fullScreen);
            },
            //todo:refactor
            handleScroll(vertical) {
                let delta = parseInt(this.currentScrollPosition - vertical.scrollTop);
                this.currentScrollPosition = vertical.scrollTop;
                this.visibleNav(delta);
            },
            closeList() {
                this.setActiveList({});
                this.$router.push({ name: 'check-lists', query: this.$route.query}).catch(() => {
                    //console.log(err);
                })
            },
            hideClick() {
                this.setFullScreen(!this.fullScreen)
            },
            tabClick(index) {
                this.currentTab = index
            },
            handleClick() {
                this.setControlsVisibility(null)
            }

        },
        created() {
            this.$store.commit('setAppClass', 'check-lists-component');
            this.getLists();
            let postId = this.$route.params.id;
            if (postId) {
                this.getList(postId);
            }
            this.setHeaderNavItems(this.tabs);
            this.setHeaderNavActive(this.tabs[0].id)
        },
        beforeRouteLeave(t0, from, next) {
            this.setHeaderNavItems([]);
            next()
        },
        updated() {
            if (this.editing) {
                this.$store.commit('setHeaderVisible', false)
            } else {
                this.$store.commit('setHeaderVisible', true)
            }
        }

    }
</script>


<style scoped>
    .loading-box {
        margin-top: 200px;
    }
</style>
